/* eslint-disable @typescript-eslint/no-explicit-any */
// IMPORTANT: This file should contain no imports besides the one below.
import { getHistoryStack, getLocation, parseState, STACK_KEY } from './history';

type Func = (...args: any) => any;

type Intercept<F extends Func> = (next: F, ...args: Parameters<F>) => void;

initNavigation();

/**
 * This is called directly after a navigation has occurred; either via the
 * browser's back/forward button (and history.back/go) or via
 * history.pushState/replaceState.
 */
function onNavigationChange() {
  // TODO: Do we need this? Previously we were using this to serialize state to
  // sessionStorage.
}

window.addEventListener('popstate', () => {
  onNavigationChange();
});

patch(history, 'pushState', (next, state, title, url) => {
  let [key, otherState] = parseState(state);
  let stack = getHistoryStack();
  stack.push(getLocation());
  let newState = {
    key: key || createKey(),
    ...otherState,
    [STACK_KEY]: stack,
  };
  let returnValue = next(newState, title, url);
  onNavigationChange();
  return returnValue;
});

patch(history, 'replaceState', (next, state, title, url) => {
  let [key, otherState] = parseState(state);
  let stack = getHistoryStack();
  let newState = {
    key: key || createKey(),
    ...otherState,
    [STACK_KEY]: stack,
  };
  let returnValue = next(newState, title, url);
  onNavigationChange();
  return returnValue;
});

function initNavigation() {
  let [initialKey, otherState] = parseState(history.state);
  if (!initialKey) {
    const newKey = createKey();
    history.replaceState(
      { key: newKey, ...otherState },
      document.title,
      location.pathname + location.search + location.hash,
    );
  }
}

function patch<T extends object, K extends keyof T>(
  obj: T,
  key: K,
  fn: T[K] extends Func ? Intercept<T[K]> : never,
): T {
  let original = obj[key];
  if (typeof original === 'function') {
    let originalFn = original.bind(obj);
    obj[key] = (function (...args: Array<any>) {
      return fn(originalFn, ...(args as never));
    } as any) as T[K];
  }
  return obj;
}

function createKey() {
  return '_' + Math.floor(Math.random() * 36 ** 8).toString(36);
}
